import Axios from 'axios';
import config from './config';

const axios = Axios.create({
	baseURL: config.API_BASE_URL
});
export default axios;
